import React from 'react';
import { colors } from '@mui/material';
import BarChartIcon from '@mui/icons-material/BarChart';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ChatIcon from '@mui/icons-material/ChatOutlined';
import CodeIcon from '@mui/icons-material/Code';
import DashboardIcon from '@mui/icons-material/DashboardOutlined';
import ErrorIcon from '@mui/icons-material/ErrorOutline';
import FolderIcon from '@mui/icons-material/FolderOutlined';
import HomeIcon from '@mui/icons-material/HomeOutlined';
import ListAltIcon from '@mui/icons-material/ListAlt';
import LockOpenIcon from '@mui/icons-material/LockOpenOutlined';
import MailIcon from '@mui/icons-material/MailOutlined';
import PresentToAllIcon from '@mui/icons-material/PresentToAll';
import PeopleIcon from '@mui/icons-material/PeopleOutlined';
import PersonIcon from '@mui/icons-material/PersonOutlined';
import ReceiptIcon from '@mui/icons-material/ReceiptOutlined';
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import DesktopMacIcon from '@mui/icons-material/DesktopMac';
import AssignmentIcon from '@mui/icons-material/Assignment';
import TroubleshootIcon from '@mui/icons-material/Troubleshoot';
import FactCheckIcon from '@mui/icons-material/FactCheck';

import { Label } from 'components';

import config from '../../../../configuration/configuration.js';

export default [
	{
		title: '',
		pages: [
			{
				title: 'Home',
				href: '/home',
				icon: HomeIcon,
				// roles: ['Administrator', ...]
				// projects: ['Operations'],
			},
		],
	},
	{
		title: 'Modules',
		pages: [
			// {
			// 	title: 'Site Tracker',
			// 	href: '/modules/siteTracker',
			// 	roles: ['Administrator', 'Manager', 'CelfinetHQ'],
			// 	icon: AssignmentIcon
			// },
			{
				title: 'Tracker',
				href: '/modules/SiteTracker',
				// roles: ['Administrator', 'Manager'],
				icon: DashboardIcon,
				children: [
					{
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
						title: 'Site Tracker',
						href: '/modules/siteTracker'
					},
					{
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
						title: 'MergeCO Tracker',
						href: '/modules/mergeCoTrackerDashboard'
					}
				],
			},
			{
				title: 'Bridge Call',
				href: '/modules/bridgeCall',
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
				icon: PeopleIcon
			},
			{
				title: 'Integrity',
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
				href: '/modules/integrity',
				icon: ChatIcon,
				children: [
					{

						title: 'Data Integrity',
						href: '/modules/integrity/dataintegrity',
					},
					{
						title: 'Forecast Integrity',
						href: '/modules/integrity/forecastintegrity'
					}
					/* 					,
					{
						title: 'Process Performance KPIs',
						href: '/modules/integrity/processperformancekpis'
					} */
				]
			},
			{
				title: 'Reports',
				// href: '/modules',
				// roles: ['Administrator', 'Manager'],
				icon: DashboardIcon,
				children: [
					{
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
						title: 'Report OPS',
						href: '/modules/reportsKpisOps'
					},
					{
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
						title: 'Report VMO2',
						href: '/modules/reportsKpisVmo2'
					},
					// {
					// 	roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
					// 	title: 'Report RAN',
					// 	href: '/modules/reportsKpisRan'
					// },
					{
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
						title: 'Reports Acceptance',
						href: '/modules/reportsAcceptance'
					}
				],
			},
			{
				title: 'Site Audit',
				href: '/modules/siteAudit',
				icon: FactCheckIcon,
				children: [
					{
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
						title: 'KPIs Check',
						href: '/modules/siteAudit/kpisCheck'
					},
				],
			},
			// {
			// 	title: 'Reports',
			// 	href: '/modules/reportsKpis',
			// 	roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
			// 	icon: AssignmentIcon
			// },
			{
				title: 'Merged CO KPIS',
				href: '/modules/mergecokpis',
				icon: TroubleshootIcon,
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
				children: [
					{
						title: 'VMO2',
						href: '/modules/mergecokpis/vmo2',
						children: [
							/* 							{
								title: 'Daily',
								children: [
									{
										title: 'Standard 4G',
										href: '/modules/mergecokpis/vmo2/daily/vmo2standard4g',
									},
									{
										title: 'PLMN 4G',
										href: '/modules/mergecokpis/vmo2/daily/vmo2plmn4g'
									}
								]
							}, */
							{
								title: 'Hourly',
								children: [
									{
										title: 'Standard 4G',
										href: '/modules/mergecokpis/vmo2/vmo2standard4g',
									},
									{
										title: 'Standard 5G',
										href: '/modules/mergecokpis/vmo2/vmo2standard5g'
									}
								]
							},
							{
								title: 'CWP',
								href: '/modules/mergecokpis/vmo2/cwp',
							}
						]
					},
					{
						title: 'VDF',
						href: '/modules/mergecokpis/vdf',
						children: [
							{
								title: 'Daily',
								children: [
									{
										title: 'Standard 4G',
										href: '/modules/mergecokpis/vdf/daily/vdfstandard4g',
									},
									{
										title: 'PLMN 4G',
										href: '/modules/mergecokpis/vdf/daily/vdfplmn4g'
									}
								]
							},
							{
								title: 'Hourly',
								children: [
									{
										title: 'Standard 4G',
										href: '/modules/mergecokpis/vdf/vdfstandard4g',
									},
									{
										title: 'Standard 5G',
										href: '/modules/mergecokpis/vdf/vdfstandard5g'
									}
								]
							}
						]
					},
					{
						title: 'THREE',
						href: '/modules/mergecokpis/three',
						children: [
							{
								title: 'Daily',
								children: [
									{
										title: 'Standard 4G',
										href: '/modules/mergecokpis/three/daily/threeukstandard4g',
									},
									{
										title: 'PLMN 4G',
										href: '/modules/mergecokpis/three/daily/threeukplmn4g'
									}
								]
							},
							{
								title: 'Hourly',
								children: [
									{
										title: 'Standard 4G',
										href: '/modules/mergecokpis/three/threeukstandard4g',
									},
									{
										title: 'Standard 5G',
										href: '/modules/mergecokpis/three/threeukstandard5g'
									}
								]
							}
						]
					},
					/* 	{
						title: 'MergeCO KPIs Standard',
						href: '/modules/mergecokpis/mergeCoKpisStandard'
					}, */
					{
						title: 'Acceptance',
						href: '/modules/mergecokpis/acceptance',
						children: [
							{

								title: 'Cluster Acceptance',
								href: '/modules/mergecokpis/acceptance/clusteracceptance',
							},
							{
								title: 'Rollback',
								href: '/modules/mergecokpis/acceptance/rollback'
								// children: [
								// 	{
								// 		title: 'Site',
								// 		href: '/modules/mergecokpis/acceptance/rollback'
								// 	},
								// 	{
								// 		title: 'Cell',
								// 		href: '/modules/mergecokpis/acceptance/rollbackCell'
								// 	}
								// ]
							}
						]
					}
				],
			},
			{
				title: 'Host Tools',
				href: '/modules/hostTools',
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
				icon: LockOpenIcon
			},
			{
				title: 'Scripts',
				href: '/modules/scriptsGeneration',
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
				icon: ViewModuleIcon
			},
			// {
			// 	title: 'Dasboards',
			// 	href: '/dasboards',
			// 	// roles: ['Administrator', 'Manager'],
			// 	icon: DashboardIcon,
			// 	children: [
			// 		{
			// 			title: 'DashboardOne',
			// 			href: '/dashboards/DashboardOne',
			// 		}
			// 	],
			// },
		],
	},
	{
		title: 'Management',
		pages: [
			{
				title: 'Manage',
				href: '/management',
				roles: ['Administrator', 'Manager'],
				icon: SupervisorAccountIcon,
				children: [
					{
						title: 'Operators',
						href: '/management/operators',
					},
					{
						title: 'Users',
						href: '/management/users',
					}
				],
			},
			{
				title: 'Hangfire',
				href: `${config.API_URL}hangfire?access_token={token}`,
				target: '_blank',
				roles: ['Administrator'],
				icon: DesktopMacIcon
			},
			{
				title: 'Settings',
				href: '/management/settings',
				icon: SettingsIcon
			},
		],
	},
];
